// RITA-1585 — Adresse der Kachel „Einstellungen › Handbuch“ mit Kapitel: Ziel des Links „Ganzes Handbuch im neuen
// Tab öffnen“ und Einstieg der Kachel. Pfad-Strings nur aus routes/paths.ts; Kapitel als Abfrageparameter, wie
// andere Unteransichten im PRM (`?bereich=`, `?vorgang=`).
import { PagePathname } from '../../../routes/paths';
import { gueltigeKapitelwahl, Kapitelwahl } from './handbuecher';

export const HANDBUCH_PARAMETER = 'handbuch';
export const KAPITEL_PARAMETER = 'kapitel';

export function handbuchAdresse(wahl: Kapitelwahl): string {
  const parameter = new URLSearchParams({ [HANDBUCH_PARAMETER]: wahl.handbuchId, [KAPITEL_PARAMETER]: wahl.kapitelId });
  return `${PagePathname.handbuch}?${parameter.toString()}`;
}

/** Kapitel aus der Adresse; fehlt eines der beiden oder gibt es die Wahl nicht, null (dann gilt das gemerkte Kapitel). */
export function kapitelwahlAusAdresse(parameter: URLSearchParams): Kapitelwahl | null {
  return gueltigeKapitelwahl(parameter.get(HANDBUCH_PARAMETER), parameter.get(KAPITEL_PARAMETER));
}
